import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "Product" }
const _hoisted_2 = { class: "Product-heroBanner" }
const _hoisted_3 = { class: "Product-presentation" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "Product-cardSection" }
const _hoisted_6 = { class: "Product-care" }
const _hoisted_7 = { class: "Product-careInfos" }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "Product-careLink" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "Product-careLink" }
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "Product-careLink" }
const _hoisted_15 = {
  key: 1,
  class: "Product-careList"
}
const _hoisted_16 = { class: "Product-careItem" }
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "Product-careItem" }
const _hoisted_19 = ["src"]
const _hoisted_20 = { class: "Product-careItem" }
const _hoisted_21 = ["src"]
const _hoisted_22 = { class: "Product-careButtonContainer" }
const _hoisted_23 = { class: "ModalCare-title" }
const _hoisted_24 = { class: "ModalCare-text" }
const _hoisted_25 = ["innerHTML"]
const _hoisted_26 = { class: "ModalCare-instructionsBg" }
const _hoisted_27 = { class: "_List" }
const _hoisted_28 = ["innerHTML"]
const _hoisted_29 = ["innerHTML"]
const _hoisted_30 = ["innerHTML"]
const _hoisted_31 = ["innerHTML"]
const _hoisted_32 = ["innerHTML"]
const _hoisted_33 = { class: "ModalCare-instructionsBg" }
const _hoisted_34 = { class: "ModalCare-instructionsTitle" }
const _hoisted_35 = { class: "_List" }
const _hoisted_36 = ["innerHTML"]
const _hoisted_37 = ["innerHTML"]
const _hoisted_38 = ["innerHTML"]
const _hoisted_39 = ["innerHTML"]
const _hoisted_40 = ["innerHTML"]
const _hoisted_41 = { class: "ModalCare-title" }
const _hoisted_42 = { class: "ModalCare-text" }
const _hoisted_43 = ["innerHTML"]
const _hoisted_44 = ["href"]
const _hoisted_45 = { class: "ModalCare-title" }
const _hoisted_46 = { class: "ModalCare-text" }
const _hoisted_47 = ["innerHTML"]
const _hoisted_48 = { class: "Modal-title ModalCare-mainTitle" }
const _hoisted_49 = { class: "ModalCare-mainSection" }
const _hoisted_50 = { class: "ModalCare-subSection" }
const _hoisted_51 = { class: "ModalCare-subTitle" }
const _hoisted_52 = { class: "ModalCare-subText" }
const _hoisted_53 = ["src"]
const _hoisted_54 = { class: "ModalCare-subSection ModalCare-isLine" }
const _hoisted_55 = { class: "ModalCare-subTitle" }
const _hoisted_56 = { class: "ModalCare-subText" }
const _hoisted_57 = ["src"]
const _hoisted_58 = { class: "ModalCare-subSection ModalCare-isLine" }
const _hoisted_59 = { class: "ModalCare-subTitle" }
const _hoisted_60 = { class: "ModalCare-subText" }
const _hoisted_61 = ["src"]
const _hoisted_62 = { class: "ModalCare-subSection ModalCare-isLine" }
const _hoisted_63 = { class: "ModalCare-subTitle" }
const _hoisted_64 = { class: "ModalCare-subText" }
const _hoisted_65 = ["src"]
const _hoisted_66 = { class: "ModalCare-subSection" }
const _hoisted_67 = { class: "ModalCare-subTitle" }
const _hoisted_68 = { class: "ModalCare-subText" }
const _hoisted_69 = ["src"]

import {computed, watch} from 'vue';
import FOHeader from "@/fo-clone/FOHeader.vue";
import FOCard from "@/fo-clone/FOCard.vue";
import InlineSVG from "@/components/InlineSVG.vue";
import useModal from "@/hooks/Modal";
// @ts-ignore
import {Swiper, SwiperSlide} from 'swiper/vue';
import "swiper/swiper.scss";
import useGetProductInformations from "@/fo-clone/custom/FOGetProductInformations";
import FOFooter from "@/fo-clone/FOFooter.vue";
import FOModal from "@/fo-clone/FOModal.vue";
import FOCustomButton from "@/fo-clone/FOCustomButton.vue";
import ProductPageConfig from "@/components/ProductPageConfig.vue";
import {itExist} from "@/utils/general-utils";

import {useI18n} from "vue-i18n";
import {useSwiper} from "@/composables/productFilePage";

// const route = useRoute(); // WARNING: Route not used in BO

export default /*#__PURE__*/_defineComponent({
  __name: 'ProductFilePage',
  setup(__props) {

const {t} = useI18n();

// GTM commented in BO

// START - Specific to BO to get the product with the good headers
const {product, getProductInfo} = useGetProductInformations();
const {locale} = useI18n();
watch(locale, getProductInfo);
// END - Specific to BO to get the product with the good headers

const isProductLoaded = computed(() => {
  // @ts-ignore
  return itExist(product.value?.serialNumber);
});

const {openModal, closeModal, currentModal} = useModal();
const modals = {
  CARE_WARRANTY: 'product-care-warranty',
  CARE_RESTORING: 'product-care-restoring',
  CARE_INSTRUCTIONS: 'product-care-instructions',
};

const {isDesktop, resettingSwiperInstance} = useSwiper();

function visitChanelWebsite() {
  // GTM commented in BO
  Object.assign(document.createElement('a'), {
    target: '_blank',
    href: t('boutique.linkButton.url'),
  }).click();
}

function openCareInstructions() {
  // GTM commented in BO
  openModal(modals.CARE_INSTRUCTIONS);
}

function openChanelWarranty() {
  // GTM commented in BO
  openModal(modals.CARE_WARRANTY);
}

function openRestoringCare() {
  // GTM commented in BO
  openModal(modals.CARE_RESTORING);
}

function clickTermsAndConditions() {
  // GTM commented in BO
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(FOHeader, { class: "Product-logo" }),
        _createElementVNode("p", {
          class: "Product-mainText",
          innerHTML: _ctx.$t('product.presentation')
        }, null, 8, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(FOCard, { product: _unref(product) }, null, 8, ["product"])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("p", {
          class: "Product-careTitle",
          innerHTML: _ctx.$t('product.care.title')
        }, null, 8, _hoisted_8)
      ]),
      (!_unref(isDesktop) && !_unref(resettingSwiperInstance))
        ? (_openBlock(), _createBlock(_unref(Swiper), {
            key: 0,
            class: "Product-careSwiper",
            "slides-per-view": 1.4,
            "space-between": 20
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(SwiperSlide), null, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    class: "Product-careItem",
                    onClick: openCareInstructions
                  }, [
                    _createElementVNode("img", {
                      class: "Product-careImage",
                      src: require('@/fo-clone/care/care-instructions.png'),
                      alt: ""
                    }, null, 8, _hoisted_9),
                    _createElementVNode("p", _hoisted_10, [
                      _createTextVNode(_toDisplayString(_ctx.$t('product.care.instructionsLink')) + " ", 1),
                      _createVNode(InlineSVG, {
                        "fill-color": "dark",
                        src: require('@/fo-clone/care/arrow-right.svg')
                      }, null, 8, ["src"])
                    ])
                  ])
                ]),
                _: 1
              }),
              _createVNode(_unref(SwiperSlide), null, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    class: "Product-careItem",
                    onClick: openChanelWarranty
                  }, [
                    _createElementVNode("img", {
                      class: "Product-careImage",
                      src: require('@/fo-clone/care/care-warranty.png'),
                      alt: ""
                    }, null, 8, _hoisted_11),
                    _createElementVNode("p", _hoisted_12, [
                      _createTextVNode(_toDisplayString(_ctx.$t('product.care.warrantyLink')) + " ", 1),
                      _createVNode(InlineSVG, {
                        "fill-color": "dark",
                        src: require('@/fo-clone/care/arrow-right.svg')
                      }, null, 8, ["src"])
                    ])
                  ])
                ]),
                _: 1
              }),
              _createVNode(_unref(SwiperSlide), null, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    class: "Product-careItem",
                    onClick: openRestoringCare
                  }, [
                    _createElementVNode("img", {
                      class: "Product-careImage",
                      src: require('@/fo-clone/care/care-restoring.png'),
                      alt: ""
                    }, null, 8, _hoisted_13),
                    _createElementVNode("p", _hoisted_14, [
                      _createTextVNode(_toDisplayString(_ctx.$t('product.care.restoringLink')) + " ", 1),
                      _createVNode(InlineSVG, {
                        "fill-color": "dark",
                        src: require('@/fo-clone/care/arrow-right.svg')
                      }, null, 8, ["src"])
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["slides-per-view"]))
        : (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("img", {
                class: "Product-careImage",
                onClick: openCareInstructions,
                src: require('@/fo-clone/care/care-instructions.png'),
                alt: ""
              }, null, 8, _hoisted_17),
              _createElementVNode("p", {
                class: "Product-careLink",
                onClick: openCareInstructions
              }, [
                _createTextVNode(_toDisplayString(_ctx.$t('product.care.instructionsLink')) + " ", 1),
                _createVNode(InlineSVG, {
                  "fill-color": "dark",
                  src: require('@/fo-clone/care/arrow-right.svg')
                }, null, 8, ["src"])
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("img", {
                class: "Product-careImage",
                onClick: openChanelWarranty,
                src: require('@/fo-clone/care/care-warranty.png'),
                alt: ""
              }, null, 8, _hoisted_19),
              _createElementVNode("p", {
                class: "Product-careLink",
                onClick: openChanelWarranty
              }, [
                _createTextVNode(_toDisplayString(_ctx.$t('product.care.warrantyLink')) + " ", 1),
                _createVNode(InlineSVG, {
                  "fill-color": "dark",
                  src: require('@/fo-clone/care/arrow-right.svg')
                }, null, 8, ["src"])
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("img", {
                class: "Product-careImage",
                onClick: openRestoringCare,
                src: require('@/fo-clone/care/care-restoring.png'),
                alt: ""
              }, null, 8, _hoisted_21),
              _createElementVNode("p", {
                class: "Product-careLink",
                onClick: openRestoringCare
              }, [
                _createTextVNode(_toDisplayString(_ctx.$t('product.care.restoringLink')) + " ", 1),
                _createVNode(InlineSVG, {
                  "fill-color": "dark",
                  src: require('@/fo-clone/care/arrow-right.svg')
                }, null, 8, ["src"])
              ])
            ])
          ])),
      _createElementVNode("div", _hoisted_22, [
        _createVNode(FOCustomButton, {
          class: "Product-careButton",
          theme: "light",
          "is-center": "",
          onClick: visitChanelWebsite
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('boutique.linkButton.text')), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(FOFooter),
    _createVNode(FOModal, {
      "is-rounded": "",
      visible: _unref(currentModal) === modals.CARE_INSTRUCTIONS,
      "is-title-left": "",
      onModalCancel: _unref(closeModal)
    }, {
      title: _withCtx(() => [
        _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.$t('modals.instructions.title')), 1)
      ]),
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("p", {
            innerHTML: _ctx.$t('modals.instructions.text-1')
          }, null, 8, _hoisted_25),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("ul", _hoisted_27, [
              _createElementVNode("span", {
                innerHTML: _ctx.$t('modals.instructions.text-2')
              }, null, 8, _hoisted_28),
              _createElementVNode("li", {
                innerHTML: _ctx.$t('modals.instructions.text-3')
              }, null, 8, _hoisted_29),
              _createElementVNode("li", {
                innerHTML: _ctx.$t('modals.instructions.text-4')
              }, null, 8, _hoisted_30),
              _createElementVNode("li", {
                innerHTML: _ctx.$t('modals.instructions.text-5')
              }, null, 8, _hoisted_31),
              _createElementVNode("li", {
                innerHTML: _ctx.$t('modals.instructions.text-6')
              }, null, 8, _hoisted_32)
            ])
          ]),
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("p", _hoisted_34, _toDisplayString(_ctx.$t('modals.instructions.text-7')), 1),
            _createElementVNode("ul", _hoisted_35, [
              _createElementVNode("li", {
                innerHTML: _ctx.$t('modals.instructions.text-8')
              }, null, 8, _hoisted_36),
              _createElementVNode("span", {
                innerHTML: _ctx.$t('modals.instructions.text-9')
              }, null, 8, _hoisted_37),
              _createElementVNode("li", {
                innerHTML: _ctx.$t('modals.instructions.text-10')
              }, null, 8, _hoisted_38),
              _createElementVNode("li", {
                innerHTML: _ctx.$t('modals.instructions.text-11')
              }, null, 8, _hoisted_39)
            ])
          ]),
          _createElementVNode("p", {
            innerHTML: _ctx.$t('modals.instructions.text-12')
          }, null, 8, _hoisted_40)
        ])
      ]),
      _: 1
    }, 8, ["visible", "onModalCancel"]),
    _createVNode(FOModal, {
      "is-rounded": "",
      visible: _unref(currentModal) === modals.CARE_WARRANTY,
      "is-title-left": "",
      onModalCancel: _unref(closeModal)
    }, {
      title: _withCtx(() => [
        _createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.$t('modals.warranty.title')), 1)
      ]),
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_42, [
          _createElementVNode("p", {
            innerHTML: _ctx.$t('modals.warranty.paragraph')
          }, null, 8, _hoisted_43),
          _createElementVNode("p", {
            class: "ModalCare-link",
            onClick: clickTermsAndConditions
          }, [
            _createElementVNode("a", {
              href: _ctx.$t('modals.warranty.linkUrl'),
              target: "_blank"
            }, _toDisplayString(_ctx.$t('modals.warranty.linkText')), 9, _hoisted_44)
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible", "onModalCancel"]),
    _createVNode(FOModal, {
      "is-rounded": "",
      visible: _unref(currentModal) === modals.CARE_RESTORING,
      "is-title-left": "",
      onModalCancel: _unref(closeModal)
    }, {
      title: _withCtx(() => [
        _createElementVNode("span", _hoisted_45, _toDisplayString(_ctx.$t('modals.restoringCare.title')), 1)
      ]),
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_46, [
          _createElementVNode("p", {
            class: "ModalCare-mainSection",
            innerHTML: _ctx.$t('modals.restoringCare.mainParagraph')
          }, null, 8, _hoisted_47),
          _createElementVNode("div", _hoisted_48, _toDisplayString(_ctx.$t('modals.restoringCare.careTips.title')), 1),
          _createElementVNode("p", _hoisted_49, _toDisplayString(_ctx.$t('modals.restoringCare.careTips.mainParagraph')), 1),
          _createElementVNode("div", _hoisted_50, [
            _createElementVNode("div", null, [
              _createElementVNode("p", _hoisted_51, _toDisplayString(_ctx.$t('modals.restoringCare.careTips.wear.title')), 1),
              _createElementVNode("p", _hoisted_52, _toDisplayString(_ctx.$t('modals.restoringCare.careTips.wear.paragraph')), 1)
            ]),
            _createElementVNode("img", {
              class: "ModalCare-img ModalCare-isColumn",
              src: require('@/fo-clone/modal/porter.png'),
              alt: ""
            }, null, 8, _hoisted_53)
          ]),
          _createElementVNode("div", _hoisted_54, [
            _createElementVNode("div", null, [
              _createElementVNode("p", _hoisted_55, _toDisplayString(_ctx.$t('modals.restoringCare.careTips.protect.title')), 1),
              _createElementVNode("p", _hoisted_56, _toDisplayString(_ctx.$t('modals.restoringCare.careTips.protect.paragraph')), 1)
            ]),
            _createElementVNode("img", {
              class: "ModalCare-img",
              src: require('@/fo-clone/modal/proteger.png'),
              alt: ""
            }, null, 8, _hoisted_57)
          ]),
          _createElementVNode("div", _hoisted_58, [
            _createElementVNode("div", null, [
              _createElementVNode("p", _hoisted_59, _toDisplayString(_ctx.$t('modals.restoringCare.careTips.care.title')), 1),
              _createElementVNode("p", _hoisted_60, _toDisplayString(_ctx.$t('modals.restoringCare.careTips.care.paragraph')), 1)
            ]),
            _createElementVNode("img", {
              class: "ModalCare-img",
              src: require('@/fo-clone/modal/entretenir.png'),
              alt: ""
            }, null, 8, _hoisted_61)
          ]),
          _createElementVNode("div", _hoisted_62, [
            _createElementVNode("div", null, [
              _createElementVNode("p", _hoisted_63, _toDisplayString(_ctx.$t('modals.restoringCare.careTips.storage.title')), 1),
              _createElementVNode("p", _hoisted_64, _toDisplayString(_ctx.$t('modals.restoringCare.careTips.storage.paragraph')), 1)
            ]),
            _createElementVNode("img", {
              class: "ModalCare-img",
              src: require('@/fo-clone/modal/conserver.png'),
              alt: ""
            }, null, 8, _hoisted_65)
          ]),
          _createElementVNode("div", _hoisted_66, [
            _createElementVNode("div", null, [
              _createElementVNode("p", _hoisted_67, _toDisplayString(_ctx.$t('modals.restoringCare.careTips.appreciate.title')), 1),
              _createElementVNode("p", _hoisted_68, _toDisplayString(_ctx.$t('modals.restoringCare.careTips.appreciate.paragraph')), 1)
            ]),
            _createElementVNode("img", {
              class: "ModalCare-img ModalCare-isColumn",
              src: require('@/fo-clone/modal/apprecier.png'),
              alt: ""
            }, null, 8, _hoisted_69)
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible", "onModalCancel"]),
    _createVNode(ProductPageConfig)
  ]))
}
}

})